import React from 'react'
import { Modal, message} from 'antd'

class PrevImg extends React.Component {
    state = {
      alt: '',
      picUrl: '',
      visible: false, 
    }
    // 显示大图
    show = (picUrl) => {
      if (!picUrl) {
        message.warning('未定义预览图片', 1.5)
        return
      }
      this.setState({
        visible: true,
        picUrl: picUrl,
      })
    }
    // 关闭
    hide = () => this.setState({visible: false})
    render () {
      const {picUrl, visible, alt} = this.state
      return (
        <Modal
          visible={visible}
          onCancel={this.hide}
          footer={false}
          closable={false}
          zIndex={1100}
          destroyOnClose
        >
          <div className='flex-a-a' style={{minHeight: 600}}>
            <img src={picUrl || ''} style={{width: 350, height: 250,maxWidth: '100%', maxHeight: 800}} alt={alt || ''} />
          </div>
        </Modal>
      )
    }
}
export default PrevImg